import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryActionButton } from '@facet-wealth/design';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useFormActions } from 'Views/Page/Content/RightSidebar/Content/Templates/DefaultTemplate/Layout/useFormActions';
import AccountPerformanceCommentaryCard
  from 'Components/ComponentLibrary/Organisms/AccountPerformanceCommentaryCard/AccountPerformanceCommentaryCard';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box/Box';
import ActionsRow from 'Components/ComponentLibrary/Atoms/Layout/ActionsRow';

const styles = (theme) => ({
  root: {

  },
  fields: {
    padding: theme.spacing(0),
  },
  preview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(4),
  },
  previewContainer: {
    width: 350,
  },
});

const Layout = ({ classes }) => {
  const { resource } = useMetaLayoutContext();

  const {
    showActions,
    showSubmitButton,
    handleSubmit,
    submitting,
  } = useFormActions(resource);

  const label = resource.selectedOptionPrompt('timePeriod');
  const startDate = resource.attr('startDate');
  const endDate = resource.attr('endDate');
  const commentary = resource.attr('content');
  const lastUpdated = resource.attr('lastUpdated');
  const isHighlight = resource.attr('isHighlight') === 'true';
  const chartData = resource.attr('chartData');

  return (
    <Box className={classes.root}>
      <MetaFormFields
        className={classes.fields}
        resource={resource}
      />
      {showActions ? (
        <ActionsRow>
          {showSubmitButton ? (
            <PrimaryActionButton
              onClick={handleSubmit}
              loading={submitting}
              disabled={submitting}
              isFullWidth
              size="lg"
              label="Submit"
            />
          ) : null}
        </ActionsRow>
      ) : null}
      <Box className={classes.preview}>
        <Box className={classes.previewContainer}>
          <AccountPerformanceCommentaryCard
            label={label}
            startDate={startDate}
            endDate={endDate}
            performance={'3.25'}
            benchmark={'3.15'}
            commentary={commentary}
            lastUpdated={lastUpdated}
            isHighlight={isHighlight}
            chartData={chartData}
          />
        </Box>
      </Box>
    </Box>
  );
};

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
